import { FC } from "react";
import { ideasFeatures } from "../ideas.features";
import { FlagsProvider } from "flagged";

export const FeatureFlagsProvider: FC = ({ children }) => {
  return <FlagsProvider features={ideasFeatures}>{children}</FlagsProvider>;
};
